import { render } from "./PartnerAZSupload.vue?vue&type=template&id=08f6d475&scoped=true"
import script from "./PartnerAZSupload.vue?vue&type=script&lang=js"
export * from "./PartnerAZSupload.vue?vue&type=script&lang=js"

import "./PartnerAZSupload.vue?vue&type=style&index=0&id=08f6d475&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f6d475"]])

export default __exports__